import { render } from "./OiTable.vue?vue&type=template&id=e3817512&scoped=true"
import script from "./OiTable.vue?vue&type=script&lang=js"
export * from "./OiTable.vue?vue&type=script&lang=js"

import "./OiTable.vue?vue&type=style&index=0&id=e3817512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3817512"]])

export default __exports__